import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { DummyService } from 'src/app/services/dummy-service.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
    // constructor(private dummyService:DummyService) { }
    constructor() {}

    ngOnInit(): void {}

    // erro_404(): void {
    //   this.dummyService.simulaErro('404').subscribe((res: any) => {
    //     console.debug(res);
    //   });
    // }

    // erro_403(): void {
    //   this.dummyService.simulaErro('403').subscribe((res: any) => {
    //     console.debug(res);
    //   });
    // }

    // erro_401(): void {
    //   this.dummyService.simulaErro('401').subscribe((res: any) => {
    //     console.debug(res);
    //   });
    // }
}
